import http from '~/utils/http'

export function login(username: string, password: string) {
  return http.post('/admin/user/login', {
    username,
    password,
  })
}
